import { types } from 'mobx-state-tree'

import { FORTO_AVATAR, TAvatarType } from '../avatars/AvatarType'
import { IActivityMessageSection, IActivityTitle, TEXT } from '../messages/MessageSectionType'

/*
 * The Activity API is unified across different activity types
 * When possible use the views methods instead of accessing the models directly
 * API: avatar, avatarType, activityIcon, and messageContent
 */

type ExternalActivityType =
  | 'booking'
  | 'bookingRequest'
  | 'companyUserUpdate'
  | 'customsDecisionUpdate'
  | 'customsStatusUpdate'
  | 'documentUpload'
  | 'manualQuote'
  | 'manualQuoteDecline'
  | 'message'
  | 'productUpdate'
  | 'shipmentUpdate'
  | 'subscription'
  | 'transportPlanUpdated'

type InternalActivityType = 'bookingUpdate' | 'changeOperationManager' | 'communication' | 'rateUpdateApplied'

export type ActivityType = ExternalActivityType | InternalActivityType
export interface IActivity {
  _id: string
  type: ActivityType
  createdAt: string
  updatedAt: string
  referenceId: string
  internal: boolean
  deletedAt?: Date
}

export interface ICommunicationActivityJSON extends IActivity {
  freightieAuthor_id: string
  content: string
}

export interface ActorActivity {
  userAuthor_id?: string
  freightieAuthor_id?: string
}

type TDocumentActionType = 'created' | 'updated' | 'deleted'
export interface IDocumentUploadActivity extends IActivity, ActorActivity {
  document_id: string
  action: TDocumentActionType
  name: string
  role: string
}

type MessageActivitySource = 'email' | 'platform'
export interface IMessageActivityJSON extends IActivity, ActorActivity {
  content: string
  source: MessageActivitySource
}

type ProductUpdateAction = 'updated' | 'deleted'

interface BaseProduct {
  referenceId: string
  skucode: string
  hscodes: string[]
  name: string
  notes?: string
}
interface Product extends BaseProduct {
  _id: string
  createdAt: Date
  modifiedAt?: Date
  deletedAt?: Date
}

export interface IProductUpdateActivityJSON extends IActivity, ActorActivity {
  action: ProductUpdateAction
  changedFields: Partial<Product>
  productName: string
  productId: string
}

export const Activity = types
  .model('Activity', {
    _id: types.identifier(types.string),
    type: types.string,
    createdAt: types.Date,
    updatedAt: types.Date,
    referenceId: types.string,
    internal: types.boolean,
  })
  .preProcessSnapshot((snapshot) => ({
    ...snapshot,
    createdAt: new Date(snapshot.createdAt),
    updatedAt: new Date(snapshot.updatedAt),
  }))
  .views(() => ({
    get activityIcon(): string | null {
      return null
    },
    get avatar() {
      return 'A'
    },
    get avatarType(): TAvatarType {
      return FORTO_AVATAR
    },
    get messageContent(): IActivityMessageSection[] {
      return [
        {
          type: TEXT,
          content: '',
        },
      ]
    },
    get title(): IActivityTitle {
      return { text: 'Generic Activity' }
    },
  }))

export type TActivity = typeof Activity.Type
